

















































































































import {Component, Watch, Prop, Mixins} from 'vue-property-decorator'
import {FileObject} from 'image-compressor.js'
import {AppConfig} from '@/config/app.config'
import {UploadConfig} from '@/config/upload.config'
import {Progress} from 'vue-progress'
import {MixinUpload, info} from 'simpli-web-sdk'
import Pdf from 'vue-pdf'
import * as Helper from '@/helpers'

@Component({
  components: {Pdf},
})
export default class ItUpload extends Mixins(MixinUpload) {
  @Prop({type: Array, default: () => []}) value!: string[]
  @Prop({type: String, default: null}) labelDragFiles?: string | null
  @Prop({type: String, default: null}) labelAddFiles?: string | null
  @Prop({type: String, default: null}) labelCancel?: string | null
  @Prop({type: String, default: null}) labelSend?: string | null
  @Prop({type: Object, default: () => new UploadConfig()}) config!: UploadConfig
  @Prop({type: Boolean, default: false}) showButtons?: boolean

  Helper = Helper

  readonly UPLOAD_CONFIG = this.config

  dragMode = true
  uploadMode = false

  get urls() {
    return this.value
  }

  set urls(val: string[]) {
    this.$emit('input', val)
  }

  get progressOptions() {
    return {
      color: AppConfig.primaryColor,
      trailColor: AppConfig.tertiaryColor,
      strokeWidth: 2.5,
    }
  }
  replicarCTE = false
  changeReplicarCTE() {
    this.$emit('changeReplicarCTE')
  }
  async switchToDragMode() {
    this.uploadMode = false
    await Helper.sleep(450)
    this.dragMode = true
  }

  async switchToUploadMode() {
    this.dragMode = false
    await Helper.sleep(450)
    this.uploadMode = true
  }

  @Watch('files')
  async filesEvent(files: FileObject[]) {
    if (files.length) {
      await this.switchToUploadMode()
    } else {
      await this.switchToDragMode()
    }
    this.$emit('changed', files)
  }

  @Watch('files', {deep: true})
  async filesEventDeep(files: FileObject[]) {
    for (const [i, file] of files.entries()) {
      const el = this.$refs[`progress${i}`] as Progress[]
      const component = el ? el[0] : null
      if (component) {
        component.animate(Number(file.progress) / 100)
      }
    }
  }

  cancel() {
    this.$emit('cancel')
  }

  async send() {
    if (this.files.length) {
      await this.startUpload()
    } else {
      info('system.info.noNewFilesSent')
      await this.onUploadEnd([])
    }
  }

  /**
   * @overwrite from MixinUpload
   * Event when the upload starts
   */
  async onUploadStart() {
    this.$emit('start')
  }

  /**
   * @overwrite from MixinUpload
   * Event when the upload ends
   */
  async onUploadEnd(urls: string[]) {
    this.urls = this.urls.concat(urls)
    this.files = []
    this.$emit('ended', urls)
  }

  removePrevImage(index: number) {
    this.urls.splice(index, 1)
  }

  get allowedExtensions() {
    const allowedExtensionList = this.UPLOAD_CONFIG.extensions
    let formattedList

    if (!allowedExtensionList) {
      return
    }

    if (Array.isArray(allowedExtensionList)) {
      formattedList = allowedExtensionList.join(', ')
    }

    if (typeof allowedExtensionList === 'string') {
      formattedList = allowedExtensionList.toString()
    }

    if (allowedExtensionList instanceof RegExp) {
      formattedList = allowedExtensionList.source
    }

    return this.$t('app.allowedFileType', { files: formattedList })
  }
}
